import _ from 'lodash'
import { Enums, Entities } from '@/model/util'

import { Company, SegmentEnum } from '@/model/company'
import { BrandEnum } from '@/model/environment'

export const SalesPointChannelEnum = { id: 'salesPointChannel' }
export const SalesPointAudienceEnum = { id: 'salesPointAudience' }

export const SalesPointTagTypeEnum = Enums.create('salesPointTagType', {
  BRAND: Enums.value('brand', 'salespoint.brands', { enum: BrandEnum }),
  SEGMENT: Enums.value('segment', 'salespoint.segments', { enum: SegmentEnum })
})

export class SalesPoint {
  static read = {
    id: undefined,
    channel: undefined
  }
  static update = {
    name: undefined,
    published: false,
    garage_concept: false,
    external_id: undefined
  }

  constructor (data) {
    Object.assign(this, SalesPoint.read, SalesPoint.update, data)
    this.company = new Company(this.company)
  }

  asCreate () {
    const result = this.asUpdate()
    Entities.addReference(result, this, 'related_company')
    Entities.addReference(result, this, 'brand')
    return result
  }

  asUpdate () {
    const result = _.pick(this, _.keys(SalesPoint.update))
    result.subject_company = Entities.asUpdate(this.company)
    Entities.addReference(result, this, 'channel')
    return result
  }
}

export class SalesPointTag {
  static read = {
    id: undefined,
    type: undefined,
    value: undefined
  }

  constructor (data) {
    Object.assign(this, SalesPointTag.read, data)
    this.type = Enums.apply(this.type, SalesPointTagTypeEnum)
  }

  static for (type, value) {
    return new SalesPointTag({ type: type, value: value })
  }

  static grouped (tags) {
    const groups = _.map(SalesPointTagTypeEnum.values, type => {
      return {
        type: type,
        values: []
      }
    })
    _.each(tags, tag => {
      const group = _.find(groups, g => Entities.areEqual(g.type, tag.type))
      group && group.values.push(tag.value)
    })
    return groups
  }

  asCreate () {
    return this.asUpdate()
  }

  asUpdate () {
    const result = {}
    Entities.addReference(result, this, ['type', 'value'])
    return result
  }
}
